import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import {React, useEffect, useState} from "react";
import Header from "../../Components/GeneratePdf/Header";
import Footer from "../../Components/GeneratePdf/Footer";
import StarterQuadrantChart from "../GeneratePdf/SelfReport/StarterQuadrantChart";
import StarterChart from "../Charts/StarterChart";
import StarterSecondChart from "../Charts/StarterSecondChart";
const Starter = require("../../Assets/Images/Starter.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");


Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    textAlign: "left",
    fontFamily: "Lato",
    marginTop: "3px",
    // padding: "5px",
    textAlign: "left",
    display: "flex",
  },
  coverTitle: {
    marginBottom: "5px",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426b88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  secondsection: {
    marginTop: "5px",
    marginBottom: "5px",
    width: "100%",

    alignItems: "flex-start",

    justifyContent: "flex-start",
    fontFamily: "Lato",
  },
  subtitle: {
    fontSize: "18px",
    lineHeight: "35px",
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#426B88",
    justifyContent: "flex-start",
    display: "flex",
  },
  coverImage: {
    width: "240px",
    height: "160px",

  },
  section: {
    textAlign: "left",
    maxWidth: "800px",
  
  },
  paragraph: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#00577D",
    lineHeight: "18px",
    textAlign: "left",
    marginBottom: "5px",
    fontFamily: "Lato",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#245775",
    textAlign: "left",
    marginTop: "20px",
    fontFamily: "Lato",
  },
  covertitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#00577D",
    textAlign: "left",
    lineHeight: "25px",
    fontFamily: "Lato",
  },
  chartcontainer: {
    padding: 10,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    width: "100%",
  },
  title: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426B88",
    fontFamily: "Lato",
    marginHorizontal: 120,
  },
  imageContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 3,
    marginBottom: 3,
    width: "100%",
  },
  image: {
    width: "100%",
    maxWidth: "400px",
  
    alignSelf: "center",
  },
  item: {
    marginBottom: 5,
    color: "#00577D",
    fontSize: "12px",
    fontWeight: 400,
    textAlign: "left",
    lineHeight: "18px",
  },
  noteContainer: {
    marginTop: 5,  
   paddingVertical: 2,
  },
  
  noteBold: {
    fontSize: 12,
    fontWeight: 700, 
    color: "#245775",
  },
  
  noteText: {
    fontSize: 12,
    fontWeight: 400, 
    color: "#426B88", 
    lineHeight: 2,    
    letterSpacing: 0,  
  },
  
});
const GroupStarterQuadrantChart = ({showNote}) => {
  return (
    <View style={styles.coverSection}>
    <Header />
      <View>
        <Text style={styles.coverTitle}>Group Starter Quadrant</Text>
        <Text style={styles.paragraph}>
          Every group has a unique quadrant of origin—a "home base" shaped by
          both nature and nurture—where they feel most at ease, authentic, and
          instinctive. Unlike many personality systems in use today, these four
          quadrants offer a fresh way of understanding how groups express
          themselves in the world. They offer valuable insights into how we
          love, live, work, contribute, and lead, both personally and
          professionally.
        </Text>
        <Text style={styles.paragraph}>
          A group's starting quadrant highlights the characteristics that feel
          most authentic to their natural, primary, or dominant way of being—the
          stance or approach that most reflect their instinctive way of relating
          to themselves and others. 
        </Text>
        <Text style={styles.paragraph}>
          Consider how the group is perceived by others, and try to separate the
          group’s perceived ideal from its genuine identity. Remember, no
          quadrant is superior to another; each is essential for achieving
          wholeness and health within the group. While all four quadrants play a
          crucial role, one often emerges as the primary starting point.
        </Text>
        <Text style={styles.paragraph}>
          Combining the scores of each individual allows for a collective result
          to emerge. This Starter Quadrant reflects the most natural or
          strongest energy and behaviors that drive the group. Comparing an
          individual’s result with that of the team or group fosters a deeper
          understanding of their feelings and experiences of connection,
          appreciation, and alignment with others.
        </Text>
      </View>
      <View style={styles.secondsection}>
        <Text style={styles.subtitle}>STARTER QUADRANT OVERVIEW CHART</Text>
            <View style={styles.imageContainer}>
              <StarterChart />
            </View>
            <View>
                {showNote && (
              <View style={styles.noteContainer}>
              <Text>
                <Text style={styles.noteBold}>Note:</Text>  
                <Text style={styles.noteText}> Your group's profile reflects an even distribution across the Heart and Soul quadrants.</Text>
              </Text>
            </View>      
              )}
                </View>
      </View>
      
      <Footer/>
    </View>
  );
};

export default GroupStarterQuadrantChart;
